export const userModel = () => {
    return {
        "email": "",
        "firstname": "",
        "isadmin": 0,
        "lastname": "",
        "middlename": "",
        "personuuid": "",
        "populated": "false",
        "primarygroup": {
            "groupStartMod": "",
            "groupactive": "true",
            "groupdesc": "",
            "groupexternalid": "",
            "groupid":"0",
            "groupleader": "",
            "groupname": "yo",
            "groupparentid": "",
            "grouptype": "",
            "groupuuid": "",
            "groupwidgetlist": "",
            "populated": ""
        },
        "username": "",
        "isLoggedIn":false
    }
};
